<template>
  <Navigation :is-background="isNotHome" />
  <router-view  />
</template>

<script setup>
import Navigation from "@/components/Navigation";
import { useRoute } from 'vue-router'
import {computed} from "vue";

const route = useRoute()
const isNotHome = computed(() => route.path !== '/')
</script>
<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(90deg, #1976D2 0%, #03A9F4 100%);
  min-height: 100vh;
}
</style>
